module.exports = __webpack_public_path__ + "res/dummy_reels_sp3.20e82adea14a33089d69103dd7b5b126.mp4";